import { useSearchParams } from 'react-router'
import Alert from '@cloudscape-design/components/alert'
import Box from '@cloudscape-design/components/box'

export default function SubscribePage() {
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('session_id')

  return (
    <Box padding="xxl">
      {sessionId ? (
        <Alert type="success" header="Subscription successful">
          Your subscription has been activated successfully. Welcome to Sabar!
        </Alert>
      ) : (
        <Alert type="info" header="Subscribe">
          Choose a plan to get started with Sabar.
        </Alert>
      )}
    </Box>
  )
}
